module.exports = __webpack_public_path__ + "static/media/wallet-43.9f9fc5ed.svg";